export const declaredProducts = {
  title: 'Declared products',
  resourceName: 'Declared products',
  titles: {
    list: 'Declared product list',
    detail: 'Declared product details',
    create: 'Add declared product',
    edit: 'Edit declared product',
    addQuick: 'Quick add',
  },
  sections: {
    basic: 'Basic information',
    audit: 'System',
    linkedInternalProducts: 'Linked internal products',
  },
  hints: {
    codeStaff: 'SPKB code is entered by staff',
  },
  fields: {
    code: 'SPKB code',
    name: 'Declared product name',
    description: 'Description',
    note: 'Notes',
    status: 'Status',
    onOffAction: 'On / Off',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    actions: 'Actions',
    internalCode: 'Internal product code',
    internalName: 'Internal product name',
    internalProduct: 'Internal product',
  },
  status: {
    active: 'Active',
    inactive: 'Inactive',
  },
  actions: {
    addInternalProduct: 'Add internal product',
  },
  messages: {
    noData: 'No declared products yet',
    noLinkedProducts: 'No internal products linked',
    exportSuccess: 'Export completed successfully',
    exportFailed: 'Export failed',
    importSuccess: 'Import completed successfully',
    importFailed: 'Import failed',
    importDescription: 'Use the provided Excel template to import declared products (supports many-to-many links to internal products).',
  },
}
